module.exports = __webpack_public_path__ + "img/rapa-nui.8d15c20a.svg";